export const roomTypes = [
    {
        id: 'club-standart',
        title: 'Сюит Джуниор - 18 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/1/1.jpg',
            '/Assets/Rooms/1/2.jpg',
            '/Assets/Rooms/1/3.jpg',
        ],
        price: 'от 8 900 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Стандарт первой категории - 14 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/2/1.jpg',
            '/Assets/Rooms/2/2.jpg',
        ],
        price: 'от 7 100 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Сюит Джуниор - 44 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/3/1.jpg',
            '/Assets/Rooms/3/2.jpg',
            '/Assets/Rooms/3/3.jpg',
            '/Assets/Rooms/3/4.jpg',
            '/Assets/Rooms/3/5.jpg',
            '/Assets/Rooms/3/6.jpg',
            '/Assets/Rooms/3/7.jpg',
            '/Assets/Rooms/3/8.jpg',
        ],
        price: 'от 9 100 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Улучшенный первой категории - 14 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/4/1.jpg',
            '/Assets/Rooms/4/2.jpg',
        ],
        price: 'от 7 600 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Полулюкс первой категории - 29 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/5/1.jpg',
            '/Assets/Rooms/5/2.jpg',
            '/Assets/Rooms/5/3.jpg',
            '/Assets/Rooms/5/4.jpg',
            '/Assets/Rooms/5/5.jpg',
        ],
        price: 'от 8 500 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Улучшенный первой категории - 12 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Односпальная кровать', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/6/1.jpg',
            '/Assets/Rooms/6/2.jpg',
        ],
        price: 'от 8 100 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Сюит Джуниор Корпус №2 - 28 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/7/1.jpg',
            '/Assets/Rooms/7/2.jpg',
            '/Assets/Rooms/7/3.jpg',
        ],
        price: 'от 8 500 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Сюит Джуниор Корпус №2 - 30 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/8/1.jpg',
            '/Assets/Rooms/8/2.jpg',
            '/Assets/Rooms/8/3.jpg',
            '/Assets/Rooms/8/4.jpg',
        ],
        price: 'от 8 500 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Сюит Джуниор Корпус №2 - 30 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/9/1.jpg',
            '/Assets/Rooms/9/2.jpg',
            '/Assets/Rooms/9/3.jpg',
            '/Assets/Rooms/9/4.jpg',
            '/Assets/Rooms/9/5.jpg',
        ],
        price: 'от 8 500 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Люкс Корпус №2 - 30 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/10/1.jpg',
            '/Assets/Rooms/10/2.jpg',
            '/Assets/Rooms/10/3.jpg',
        ],
        price: 'от 11 000 руб/сутки',
    },

];